<div *ngIf="loadingSavedView" class="alert alert-info">
    Loading Saved View...
  </div>

<div *ngIf="savedView && !loadingSavedView" class="alert alert-primary">
  Viewing <b>{{ savedView.name }}</b>
  <span class="badge badge-primary ml-2" *ngIf="savedView.id === personalDefaultViewId">
    Personal Default
  </span>
  <span class="badge badge-primary ml-2" *ngIf="savedView.id === organizationDefaultViewId">
    Org Default
  </span>

  <div class="float-right">
    <button class="btn btn-sm btn-outline-primary alert-btn"
            (click)="renameView.emit()">
      Rename View
    </button>
    <button class="btn btn-sm btn-outline-danger alert-btn ml-2"
            (click)="deleteView.emit()">
      Delete View
    </button>
    <ng-container *ngIf="savedViewEdited">
      <button class="btn btn-sm btn-outline-primary alert-btn ml-2"
              (click)="saveChanges.emit()">
        Save Changes
      </button>
      <button class="btn btn-sm btn-outline-primary alert-btn ml-2"
              (click)="saveAsNew.emit()">
        Save as New View
      </button>
    </ng-container>
  </div>
</div>

<div *ngIf="!savedView && !loadingSavedView && savedViewEdited" class="d-block mb-3">
  <button class="btn btn-sm btn-outline-primary"
          (click)="saveAsNew.emit()">
    Create Saved View
  </button>
</div>
